function HorizontalDivider(index) {
  return (
    <div
      key={index}
      className="min-w-full mx-auto px-4 my-1 xl:my-2 h-1 bg-neutral-300 border-1 border-b-2 border-white"
    />
  );
}

export default HorizontalDivider;
